// @flow
// $FlowFixMe
import React, { Fragment } from 'react';
import { slugify } from '@finect/front-utils/slugify';
import { Strong } from '@finect/tabular-core/Strong';
import { Small } from '@finect/tabular-core/Small';
import { Icon } from '@finect/tabular-components/Icon';
import { AdviserBadge } from '@finect/tabular-components/AdviserBadge';
import { EntityCard } from '@finect/tabular-components/EntityCard';
import { AuthorBlock, AuthorInfo } from './partials';

type Props = {
  author: {
    id: string,
    image?: string,
    name?: string,
    alias: string,
    url: string,
    type: string,
    subtype?: string,
    adviserAt?: {
      id: string,
      name: string,
      icon: string,
      url: string,
      badges: Array<string>,
      features: Object,
      private: boolean
    },
    certification?: {
      name: string,
      icon: string,
      url: string
    },
    features: Array<string>
  },
  action: string,
  isUser: boolean,
  main?: boolean,
  loggedIn?: boolean
};

export const Author = ({ author, action, isUser, main, loggedIn }: Props) => {
  const { id, type, name, alias, image, url, adviserAt: company, certification, features = [] } = author;
  const { badges = [] } = company || {};

  const isAdviser = badges.includes('Asesor');
  const isPro = type === 'company' || isAdviser;
  const aditionalIcon =
    !isPro && certification && certification.icon && certification.icon !== '/image/' ? { ...certification } : null;

  const cardProps = {
    type: 'profile',
    entity: {
      id,
      name,
      subtype: type === 'company' ? 'company' : 'user',
      alias,
      icon: image,
      adviser: isAdviser,
      verified: isPro,
      aditionalIcon
    },
    loggedIn
  };

  const withProfileLink = features.includes('profile');
  const iconComponent = (
    <Icon
      alt={name || alias}
      size={main ? 3 : 2}
      image={image}
      url={withProfileLink ? url : null}
      type={type === 'company' ? 'company' : 'user'}
      margin="0 12px 0 0"
      aditionalIcon={aditionalIcon}
      verified={isPro}
    />
  );

  const nameComponent = (
    <Strong>
      {withProfileLink ? (
        <a href={url} title={`Ver perfil de ${name || alias}`}>
          {name || alias}
        </a>
      ) : (
        <span>{name || alias}</span>
      )}

      {badges.map((badge, index) => (
        <Fragment key={index}>
          {' '}
          <AdviserBadge title={badge} />
        </Fragment>
      ))}
    </Strong>
  );
  const companyAlias = company ? (company.url && company.url.replace('/grupos/', '')) || slugify(company.name) : '';
  const companyHasBlog = company && company.features && company.features.blog && !company.private;
  const companyComponent =
    company && companyHasBlog ? (
      <Small>
        <a href={company.url} title={`Ver perfil de ${company.name}`}>
          {company.name}
        </a>
      </Small>
    ) : null;

  return (
    <AuthorBlock badge={isAdviser}>
      {!isUser ? (
        <EntityCard {...cardProps} arrowPosition={main ? 21 : null}>
          {iconComponent}
        </EntityCard>
      ) :
        iconComponent
      }

      <AuthorInfo>
        {!isUser ? <EntityCard {...cardProps}>{nameComponent}</EntityCard> : nameComponent} {action}:
        {!isUser && company ? (
          <div>
            {companyHasBlog && companyComponent ? (
              <EntityCard
                type="profile"
                entity={{
                  id: company.id,
                  subtype: 'company',
                  name: company.name,
                  alias: companyAlias
                }}
              >
                {companyComponent}
              </EntityCard>
            ) : (
              <Small>{company.name}</Small>
            )}
          </div>
        ) :
          companyComponent && <div>{companyComponent}</div>
        }
        {!isPro && certification && (
          <div>
            <Small>Certificación {certification.name}</Small>
          </div>
        )}
      </AuthorInfo>
    </AuthorBlock>
  );
};
